module.exports = __webpack_public_path__ + "img/InfoMenu.5798f75a.svg";